/**
 * Function to detect if the user is browsing from a mobile device.
 * It checks the user agent string against known mobile device patterns.
 *
 * @returns {boolean} True if the user is browsing from a mobile device, otherwise false.
 */
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export default isMobile;